import "./bottomNavigation.scss";

// Shared 24px stroke icon props — identical to the customer BottomNavigation
// so the Service Worker bar renders with the exact same visual language
// (size, stroke, round caps/joins). Icons only; Persian names live in the
// nav item aria-label/title, never as visible text.
export const SERVICE_WORKER_ICON_PROPS = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: false,
};

// 1. Recent Services — clock/history mark for services the worker registered.
export function RecentServicesIcon() {
  return (
    <svg {...SERVICE_WORKER_ICON_PROPS}>
      <circle cx="12" cy="12" r="10" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

// 2. Customers — two-person mark for customer management.
export function CustomersIcon() {
  return (
    <svg {...SERVICE_WORKER_ICON_PROPS}>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  );
}

// 3. Register Service — clipboard-plus mark for creating a new service.
export function RegisterServiceIcon() {
  return (
    <svg {...SERVICE_WORKER_ICON_PROPS}>
      <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
      <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
      <path d="M12 11v6" />
      <path d="M9 14h6" />
    </svg>
  );
}

// 4. Service Worker Dashboard — grid mark for the main worker dashboard.
export function ServiceWorkerDashboardIcon() {
  return (
    <svg {...SERVICE_WORKER_ICON_PROPS}>
      <rect x="3" y="3" width="7" height="7" />
      <rect x="14" y="3" width="7" height="7" />
      <rect x="14" y="14" width="7" height="7" />
      <rect x="3" y="14" width="7" height="7" />
    </svg>
  );
}

// 5. CRM — briefcase mark for customer-relationship management.
export function CrmIcon() {
  return (
    <svg {...SERVICE_WORKER_ICON_PROPS}>
      <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
      <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
    </svg>
  );
}

// 6. User Panel — single-person mark for the user panel.
export function UserPanelIcon() {
  return (
    <svg {...SERVICE_WORKER_ICON_PROPS}>
      <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
      <circle cx="12" cy="7" r="4" />
    </svg>
  );
}
